import React, { Component } from "react";
import { func, string } from "prop-types";
import Col from "../../../../common/grid/Col.js";
import Input from "../../../../common/input/Input.js";
import AttachmentUploader from "../../../../common/attachment/AttachmentUploader.js";

class BudgetBlock extends Component {
  static propTypes = {
    budget: string,
    onChange: func
  };

  render() {
    return (
      <Col _bottom-16>
        <div>
          <label htmlFor="budget" className="key">
            project budget:
          </label>
          <Input
            name="budget"
            value={this.props.budget}
            onChange={this.props.onChange}
            ph="Project Budget"
          />
        </div>

        <AttachmentUploader
          name="budget_attachment"
          text="No attachments for project budget"
          typeId="3"
        />
      </Col>
    );
  }
}

export default BudgetBlock;



// WEBPACK FOOTER //
// ./src/components/main/projects/_form-blocks/BudgetBlock.js